import React from 'react'
import { amphtml } from '../../../google-amp/react_amp'
import { StyledContent } from '../../../publication/Embed/amp/AmpStyledContent.styled'

interface InnerProps {
    width: number
    height: number
    layout: 'responsive'
    'data-videoid': string
}
const AmpYoutubeElement = amphtml<InnerProps>('youtube')

export interface AmpYoutubeProps {
    videoId: string
    width: number
    height: number
}

export const AmpYoutube: React.FC<AmpYoutubeProps> = (props) => (
    <StyledContent>
        <AmpYoutubeElement
            width={props.width}
            height={props.height}
            layout="responsive"
            data-videoid={props.videoId}
        />
    </StyledContent>
)
